import React from 'react';

import { GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';

import styled from 'styled-components';

import { MenuItem } from '@mui/material';

import { PickerProps } from 'components/Grid/operators/types';

import { StyledSelect } from 'components/Input/styles';

import { createFilterRegex } from 'utils/regex';
import { ESCALATION_TYPE_LABELS, MonitoringMethod } from 'core/constants';

export const StyledMenuItem = styled(MenuItem)`
  font-size: 1.3rem;
  line-height: 2rem;
  p {
    margin: 0;
  }
`;

const MonitoringTypeOperator: React.FunctionComponent<PickerProps> = ({ applyValue, item, ...props }) => (
  <StyledSelect
    {...props}
    value={item.value}
    fullWidth
    onChange={(newValue) => applyValue({ ...item, value: newValue.target.value })}
  >
    <StyledMenuItem key="self_monitored" value="self_monitored">
      <p>Self-Monitoring</p>
    </StyledMenuItem>
    <StyledMenuItem key="arc_monitored" value="arc_monitored">
      <p>Vatix 24/7 Monitoring</p>
    </StyledMenuItem>
  </StyledSelect>
);

export default [
  {
    label: 'is',
    value: 'is',
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.value) {
        return null;
      }
      const filterRegex = createFilterRegex(filterItem.value);
      return ({ value }: { value: string }): boolean => (value != null ? filterRegex.test(value.toString()) : false);
    },
    InputComponent: MonitoringTypeOperator,
    InputComponentProps: { value: null },
    getValueAsString: (value: string) => ESCALATION_TYPE_LABELS[value as unknown as MonitoringMethod],
  },
] as unknown as GridFilterOperator[];
